import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { nestedRoutePath, routes } from '../../../../constants/routes'
import AdminImeiList from './list'
import AdminImeiCreate from './create'

const AdminImeiIndex = () => {
    return (
        <Routes>
            <Route path={nestedRoutePath(routes.adminImeiIndex.path, routes.adminImeiCreate.path, true)} element={<AdminImeiCreate />} />
            <Route index element={<AdminImeiList />} />
        </Routes>
    )
}

export default AdminImeiIndex
